module.exports = __webpack_public_path__ + "static/media/2013_dec_miles.2fa713df.jpg";